import type { VentaNocturnaPhase } from '@/shared/campaigns/venta-nocturna';
import type { CartSheetWidgetAttribute, CartSheetWidgetProps } from './types';

/** Acepta un JSON array (`["1","2"]`) o una lista separada por comas. */
function parseSavedIds(value: string | null): string[] | undefined {
  if (!value) return undefined;
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.map(String);
  } catch {
    return value
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }
  return undefined;
}

export const DEFAULT_CART_SHEET_WIDGET_PROPS: CartSheetWidgetProps = {
  country: 'CL',
};

export const OBSERVED_CART_SHEET_WIDGET_ATTRIBUTES: CartSheetWidgetAttribute[] = [
  'platform-country',
  'checkout-url',
  'empty-state-url',
  'notice',
  'notice-href',
  'vn-phase',
  'vn-saved-ids',
];

export function readCartSheetWidgetProps(element: HTMLElement): CartSheetWidgetProps {
  return {
    country:
      (element.getAttribute('platform-country') as 'CL' | 'MX' | 'CO' | null) ??
      DEFAULT_CART_SHEET_WIDGET_PROPS.country,
    checkoutUrl: element.getAttribute('checkout-url') ?? undefined,
    emptyStateUrl: element.getAttribute('empty-state-url') ?? undefined,
    notice: element.getAttribute('notice') ?? undefined,
    noticeHref: element.getAttribute('notice-href') ?? undefined,
    vnPhase: (element.getAttribute('vn-phase') as VentaNocturnaPhase | null) ?? undefined,
    savedIds: parseSavedIds(element.getAttribute('vn-saved-ids')),
  };
}
